import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export function useCreatePersonnelTrainingReportPdfMutation() {
  return useMutation({
    mutationFn: async ({ personnelId, trainingReportParams }) => {
      const response = await axios.post(
        `/personnel/${personnelId}/training_report_pdfs`,
        trainingReportParams,
      );
      return response.data;
    },
    retry: false,
  });
}
